<template>
  <section class="app-main" style="min-height: 100%">
    <!--<span>i am ap main</span>-->
    <el-alert
    title="您有一条新的订单！"
    type="success" v-if="status==1" v-on:close="handlerClose">
    </el-alert>
    <transition name="fade" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view></router-view>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
 import { SelectNewOrderCount } from '@/api/login'
  export default {
    name: 'AppMain',
    data(){
      return {
        curry_time:0,//订单最后时间
        status:0,//0不显示消息提示，1显示消息提示
      }
    },
    computed: {
      cachedViews() {
        return this.$store.state.app.cachedViews
      }
      // key() {
      //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
      // }
    },
    created(){
      this.getSelectNewOrderCount()
    },
    methods:{
      //服务器获取订单提醒
      getSelectNewOrderCount(){ 
        let { curry_time } = this;
        SelectNewOrderCount({
          curry_time
        }).then(res=>{
          let { data,status,message } = res.data
          if(status=="success"){
            let { status, time } = data
            if(status==1){
              this.status = status
            }
            this.curry_time = time
          }else{
            this.$message.error(message)
          }
          setTimeout(()=>{
            this.setStatusTime =  this.getSelectNewOrderCount()
          },10000)
        }).catch(error=>{
          setTimeout(()=>{
            this.setStatusTime = this.getSelectNewOrderCount()
          },10000)
        })
      },
      //关闭消息提醒
      handlerClose(){ 
        this.status = 0
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue